import { logEvent, setUserProperties as setFirebaseUserProperties } from "firebase/analytics"
import { analytics } from "./firebase"

class AnalyticsController {
    setUserProperties(properties = {}) {
        if (!analytics) {
            return
        }

        setFirebaseUserProperties(analytics, {
            app_name: "LandingPage",
            ...properties,
        })
    }

    async trackPageView({ title, path, location } = {}) {
        if (!analytics) {
            return
        }

        this.setUserProperties()

        logEvent(analytics, "page_view", {
            page_title: title ?? document.title,
            page_path: path ?? window.location.pathname,
            page_location: location ?? window.location.href,
        })
    }

    async trackEvent(name, params = {}) {
        if (!analytics) {
            return
        }

        logEvent(analytics, name, params)
    }
}

const analyticsController = new AnalyticsController()

export default analyticsController
